import React from "react";
import { Row, Col } from "reactstrap";
import { FormattedDate, FormattedNumber } from "react-intl";
import { Table } from "reactstrap";

import { CustomFormInput } from "../../../../utils/FormFields";

const Amortization = ({ payment }) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Settlement Date">
            <FormattedDate value={`${payment.AmortizationSettlementDate}T00:00`} />
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Status">{payment.AmortizationStatus}</CustomFormInput>
        </Col>

        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Description">{payment.AmortizationDescription}</CustomFormInput>
        </Col>
      </Row>
      <hr />
      <div>
        <Table responsive hover>
          <thead>
            <tr>
              <th>Account</th>
              <th>Custodian</th>
              <th>Currency</th>
              <th>Volume</th>
            </tr>
          </thead>
          <tbody>
            <tr key={payment.AmortizationFundId}>
              <td>{payment.AmortizationFundName}</td>
              <td>{payment.AmortizationFundCustodianName}</td>
              <td>{payment.AmortizationCurrencyISO}</td>
              <td className="text-right">
                <FormattedNumber value={payment.AmortizationAmount} dataTypeDecimalName="currency" />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </React.Fragment>
  );
};

export default Amortization;
